import {
	SET_ALL_ROOM_TYPES,
	SET_CRUISE_ITINERARY,
	SET_CRUISE_ITINERARY_POLICIES,
	SET_CRUISE_LISTING,
	SET_CRUISE_PORT_LISTING,
} from '../features/cruise/store/Constants'
import {
	RAW_ROOM_ALTERNATES,
	ROOM_ALTERNATES,
	SET_LISTING,
	SET_RAW_ROOM_ALTERNATES,
	SET_ROOM_ALTERNATES,
	SET_SEARCH_QUERY,
	SET_STAY_ITINERARY,
} from '../features/stays/store/Constants'
import isIxigoPartnersSite from '../utils/isIxigoPartnersSite'
import get from '../utils/lodashUtils/get'
import {
	SET_ALL_LANGUAGES,
	SET_IXIGO_SITE,
	SET_USER_DETAILS,
	UPDATE_DISPLAY_CURRENCY,
	UPDATE_LOCALE,
} from './Constants'

const initialState = {
	stay: {
		isFetched: false,
	},
	cruise: {
		isFetched: false,
	},
	showTcsStickyBar: false,
	isIxigoPartnersSite: isIxigoPartnersSite(),
	itineraryInfo: false,
	rawAlternateRoomOptions: {},
	alternateRooms: {},
	displayCurrency: 'INR',
}

const AppState = (state = initialState, action) => {
	// console.log({ action })
	switch (action.type) {
		case SET_ALL_LANGUAGES:
			return {
				...state,
				...action.payload,
			}
		case SET_IXIGO_SITE:
			return {
				...state,
				...action.payload,
			}
		case UPDATE_LOCALE:
			return {
				...state,
				...action.payload,
			}
		case UPDATE_DISPLAY_CURRENCY:
			return {
				...state,
				displayCurrency: action.payload,
			}
		case SET_USER_DETAILS: {
			return {
				...state,
				userDetails: { ...action.payload },
			}
		}
		case SET_LISTING:
			return {
				...state,
				stay: {
					...action.payload,
				},
			}
		case SET_STAY_ITINERARY:
			return {
				...state,
				stay: {
					...state.stay,
					itineraryInfo: { ...action.payload },
				},
			}
		case ROOM_ALTERNATES:
			return {
				...state,
				alternateRooms: {
					...state.alternateRooms,
					...action.payload,
				},
			}
		case SET_ROOM_ALTERNATES:
			return {
				...state,
				alternateRooms: {
					...action.payload,
				},
			}
		case RAW_ROOM_ALTERNATES:
			return {
				...state,
				rawAlternateRoomOptions: {
					...state.rawAlternateRoomOptions,
					...action.payload,
				},
			}
		case SET_RAW_ROOM_ALTERNATES:
			return {
				...state,
				rawAlternateRoomOptions: {
					...action.payload,
				},
			}

		case SET_SEARCH_QUERY:
			return {
				...state,
				searchQuery: {
					...action.payload,
				},
			}
		// CRUISE
		case SET_CRUISE_LISTING:
		case SET_CRUISE_PORT_LISTING:
		case SET_ALL_ROOM_TYPES:
		case SET_CRUISE_ITINERARY_POLICIES:
			return {
				...state,
				cruise: {
					...state.cruise,
					...action.payload,
				},
			}
		case SET_CRUISE_ITINERARY: {
			const itineraryInfo = action.payload

			const customCostings = get(itineraryInfo, 'customCostings')
			const cruiseCostings = customCostings.find(a => a.cruise)
			const disableBooking = cruiseCostings?.cruiseCosting?.disableBooking

			const dayDetails =
				cruiseCostings?.cruiseCosting?.routeDetail?.itineraries?.[0]?.dayDetails
			const tripDetails =
				cruiseCostings?.cruiseCosting?.routeDetail?.itineraries?.[0]
			const routeDetails =
				cruiseCostings?.cruiseCosting?.routeDetail?.routeDetails
			const costingRoomConfigs =
				cruiseCostings?.cruiseCosting?.roomCostings?.map(a => a.roomConfig)
			const polices = {
				cancellation: cruiseCostings?.cruiseCosting?.cancellationPolicies,
			}
			const finalObj = {
				...cruiseCostings.cruiseCosting,
				dayDetails,
				costingRoomConfigs,
				polices,
				...tripDetails,
				...routeDetails,
				cid: cruiseCostings?.cruiseCosting?.itineraryId,
			}

			return {
				...state,
				itineraryInfo: {
					...action.payload,
					currentCruiseDetails: finalObj,
					disableBooking,
				},
			}
		}
		default:
			return state
	}
}

export default AppState
